import { useParams } from "react-router-dom";
import ListadoGenerico from "../../utilities/ListadoGenerico/principal";
import { PlecaMorada } from "../../utilities/PlecaMorada";
import Breadcrumb from "./breadcrumb";
import Informacion from "./informacion";

export default function Main() {
    const { id } = useParams() as { id: any; }
    return(
        <>
            <Breadcrumb /> 
            <Informacion/>
            <ListadoGenerico id={id} pagina={0} seccion={3}/>
            <PlecaMorada/>
        </>
    )    
}